export var statusIconSolidType = {
  pending: 'pause-solid',
  warning: 'warning-solid',
  success: 'checked-circle-fill',
  informative: 'info-fill',
  scheduled: 'stopwatch-fill',
  processing: 'process-fill',
  help: 'help-circle-fill',
  issues: 'refresh-fill',
  cancel: 'cancel',
  decline: 'decline-fill',
  alert: 'error-fill'
};
//# sourceMappingURL=StatusIconSolid.types.js.map